module.exports = __webpack_public_path__ + "img/advantage_1.bc2d1064.png";